import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import WhyNexus from './pages/WhyNexus';
import Solutions from './pages/Solutions';
import ProfessionalServices from './pages/ProfessionalServices';
import ConsultingImplementation from './pages/ConsultingImplementation';
import ManagedServices from './pages/ManagedServices';
import Alliances from './pages/Alliances';
import Contact from './pages/Contact';
import InfrastructureSystems from './pages/InfrastructureSystems';
import NetworkSystems from './pages/NetworkSystems';
import DataCenter from './pages/DataCenter';
import InformationSecurity from './pages/InformationSecurity';
import Virtualization from './pages/Virtualization';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="why-nexus" element={<WhyNexus />} />
        <Route path="solutions" element={<Solutions />} />
        <Route path="professional-services" element={<ProfessionalServices />} />
        <Route path="consulting-implementation" element={<ConsultingImplementation />} />
        <Route path="managed-services" element={<ManagedServices />} />
        <Route path="alliances" element={<Alliances />} />
        <Route path="contact" element={<Contact />} />
        <Route path="infrastructure-systems" element={<InfrastructureSystems />} />
        <Route path="network-systems" element={<NetworkSystems />} />
        <Route path="data-center" element={<DataCenter />} />
        <Route path="information-security" element={<InformationSecurity />} />
        <Route path="virtualization" element={<Virtualization />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
